<script>
import DialogLayout from "@layouts/dialog.layout.vue";
import ImageZoom from "@components/ImageZoom.vue";

export default {
    name: "ImageDialogComponent",
    components: {
        DialogLayout,
        ImageZoom,
    },
    data() {
        return {
            dialog: false,
            id: undefined,
            context: [],
            width: 0,
        };
    },
    mounted() {
        this.width = window.innerWidth;
        window.onresize = () => (this.width = window.innerWidth);
    },
    methods: {
        async open(id, context) {
            this.id = id;
            this.context = context;
            this.dialog = true;
        },
        close(action) {
            action();
            this.$emit("input", this.dialog);
            this.$emit("close");
        },
    },
};
</script>

<template>
    <DialogLayout v-model="dialog" :fullscreen="width < 900" width="auto">
        <template #activator="{ on, attrs }">
            <slot name="activator" :on="on" :attrs="attrs" />
        </template>
        <template #content="{ action }">
            <div class="image-viewer">
                <div class="viewer-content">
                    <ImageZoom v-if="id" :src="id" :context="context" />
                    <div v-else class="loader"><v-progress-circular indeterminate /></div>
                </div>
                <div v-ripple class="viewer-close" @click="close(action)">Vorschau schliessen</div>
            </div>
        </template>
    </DialogLayout>
</template>

<style lang="scss" scoped>
.image-viewer {
    overflow: hidden !important;
    width: 90vw;
    height: 90vh;
    display: grid;
    grid-template-areas:
        "content"
        "close";
    grid-template-columns: auto;
    grid-template-rows: auto 3.5rem;
    background: #525659;

    .viewer-content {
        grid-area: content;
        background: #525659;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 90vw;
        height: calc(90vh - 3.5rem);

        .loader {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .viewer-close {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #323639;
        color: white;
        cursor: pointer;
        z-index: 500;
    }
}

@media only screen and (max-width: 900px) {
    .image-viewer {
        width: 100vw;
        height: 100vh;
        grid-template-columns: 100%;
        grid-template-rows: calc(100% - 3.5rem) 3.5rem;

        .viewer-content {
            width: 100vw;
            height: calc(100vh - 3.5rem);
        }
    }
}
</style>

<style lang="scss">
.vh--outer {
    max-width: 90vw;
    max-height: calc(90vh - 3.5rem);
}

.vh--holder {
    max-width: 90vw;
    max-height: calc(90vh - 3.5rem);

    picture {
        max-width: 90vw;
        max-height: calc(90vh - 3.5rem);

        .img {
            max-width: 90vw;
            max-height: calc(90vh - 3.5rem);
        }
    }
}

@media only screen and (max-width: 900px) {
    .vh--outer {
        max-width: 100vw;
        max-height: calc(100vh - 3.5rem);
    }

    .vh--holder {
        max-width: 100vw;
        max-height: calc(100vh - 3.5rem);

        picture {
            max-width: 100vw;
            max-height: calc(100vh - 3.5rem);

            .img {
                max-width: 100vw;
                max-height: calc(100vh - 3.5rem);
            }
        }
    }
}
</style>
